<template>
  <div class="solution">
    <pageHeader
      :actNum="2"
      :bannerImg="bannerImg"
      bannerText="- Hoist"
      bannerText2="Efficiency and quality"
    />
    <!-- <div class="background"></div>
    <div class="banner">
      <img :src="bannerImg" />
      <span>-我们的解决方案</span>
    </div> -->
    <div class="top">
      <div class="top-left">您的位置：<span class="homeSpan" @click="tarHome()">首页</span
      > > 解决方案</div>
    </div>
    <div class="content">
      <div class="content-box" v-for="(item, i) in showList" :key="i" @click="tarDetail(item)">
        <div class="content-box-img">
          <img :src="getIconPath(item.img)" />
        </div>
        <div class="content-box-title">{{ item.title }}</div>
        <div class="content-box-content">{{ item.content[1].value }}</div>
      </div>
    </div>
    <div class="paging">
      <div
        v-for="i in pageNum"
        :key="i"
        :class="{ actDiv: i == divNum }"
        @click="changDivNum(i)"
      >
        {{ i }}
      </div>
    </div>
    <footPage />
  </div>
</template>

<script>
import pageHeader from "@/components/pageHeader/index.vue";
import footPage from "@/components/foot/index.vue";
import bannerImg from "@/assets/img/banner_solution.png";
import {
  data1,
  data2,
  data3,
  data4,
  data5,
} from "@/components/pageDetail/config/solutionConfig";
export default {
  name: "solution",
  components: {
    pageHeader,
    footPage,
  },
  data() {
    return {
      bannerImg,
      dataList: [data1, data2, data3, data4, data5], //全部数据
      pageNum: 0, //分页数
      divNum: 1, //当前页
      showList: [], //展示数据
    };
  },
  methods: {
    changDivNum(i) {
      this.divNum = i;
      this.showList = [];
      this.dataList.forEach((item, index) => {
        if (index >= (i - 1) * 4 && index < i * 4) {
          this.showList.push(item);
        }
      });
      window.scrollTo(0, 0);
    },
    tarDetail(item){
      this.$router.push({
        path: "/solutionDetail",
        query: { type: item.type,},
      });
    },
    // 图片拼接
    getIconPath(iconName) {
      return require(`@/assets/img/solution/${iconName}.png`);
    },
    tarHome(){
      this.$router.push('/')
    },
  },
  created() {
    this.pageNum = Math.ceil(this.dataList.length / 4);
    this.changDivNum(1);
  },
};
</script>

<style lang="scss" scoped>
.solution {
  position: relative;
  color: #333;
  .background {
    margin-top: 90px;
    background-color: #004f6a;
    width: 100%;
    height: 300px;
  }
  .banner {
    margin: 0 auto;
    width: 1544px;
    height: 400px;
    margin-top: -210px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    span {
      position: absolute;
      top: 200px;
      left: 70px;
      font-size: 18px;
    }
  }
  .top {
    padding: 52px 260px;
    &-left {
      font-size: 15px;
    }
  }
  .content {
    margin-top: 50px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 0 260px;
    &-box {
      width: 670px;
      padding-bottom: 32px;
      box-sizing: border-box;
      cursor: pointer;
      margin-bottom: 64px;
      &-img {
        width: 100%;
        height: 418px;
        img {
          width: 100%;
          height: 100%;
          transition: all 0.36s ease;
        }
      }
      &-title {
        padding-left: 60px;
        margin-top: 40px;
        font-size: 20px;
        transition: transform 0.36s ease; /* 添加过渡效果 */
        transform: translateY(0); /* 初始位置 */
      }
      &-content {
        margin-top: 5px;
        padding: 0 60px;
        font-size: 15px;
        line-height: 28px;
        transition: transform 0.36s ease; /* 添加过渡效果 */
        transform: translateY(0); /* 初始位置 */
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    &-box:hover {
      background-color: #004f6a;
      .content-box-img {
        img {
          transform: scale(0.9, 0.9);
          transition: all 0.36s ease;
        }
      }
      .content-box-title,
      .content-box-content {
        color: #fff;
        transition: transform 0.36s ease; /* 添加过渡效果 */
        transform: translateY(-20px); /* 初始位置 */
      }
    }
  }
  .paging {
    // margin-top: 154px;
    padding: 104px 260px 175px 260px;
    display: flex;
    div {
      width: 42px;
      height: 42px;
      border: 1px solid #dcdcdc;
      line-height: 42px;
      text-align: center;
      margin-right: 10px;
      cursor: pointer;
    }
    .actDiv {
      background-color: #004f6a;
      color: #fff;
      border: 1px solid #004f6a;
    }
  }
}
</style>